import { render } from "./SlideApresentacaoRenderer.vue?vue&type=template&id=36cc5b40&scoped=true"
import script from "./SlideApresentacaoRenderer.vue?vue&type=script&lang=js"
export * from "./SlideApresentacaoRenderer.vue?vue&type=script&lang=js"

import "./SlideApresentacaoRenderer.vue?vue&type=style&index=0&id=36cc5b40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cc5b40"]])

export default __exports__